
import { call } from 'redux-saga/effects';
import { userAccountCreationStep } from '../userAccountCreationStep';

/**
 * Process all step of registration
 * @param {String} flow - current flow (eg: students, mentors)
 */
export function* studentSignupFlow({ flow = 'students', authCredentials }) {
  yield call(userAccountCreationStep, { flow, authCredentials });
  return true;
}
